import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawRadioGroup, type RawRadioGroupProps } from './RawRadioGroup'

export type RadioGroupProps<T> = RawRadioGroupProps<T> & InputProps

export const RadioGroup = <T,>({
  wrapperProps,
  ...fieldProps
}: RadioGroupProps<T>) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawRadioGroup {...fieldProps} id={id} />
    </InputWrapper>
  )
}
